import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getSupplierEmails = createApi(`SupplierEmailsSlice`, "GET");

const SupplierEmailsSlice = createSlice({
  name: 'SupplierEmailsSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSupplierEmails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSupplierEmails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getSupplierEmails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default SupplierEmailsSlice.reducer;
